var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGovernmentIcon = function SvgGovernmentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    clipPath: "url(#clip0_26_455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.05 11.354H1.102l7.975-4.557zM1.101 17.05h15.95M2.24 11.354v5.697M5.658 11.354v5.697M9.076 11.354v5.697M12.494 11.354v5.697M15.912 11.354v5.697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.519 9.381V7.367a4.557 4.557 0 0 1 9.114 0V9.38M9.076 2.81V1.1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_455"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgGovernmentIcon;